import isFinite from 'lodash/isFinite'

import SurveyValue from './SurveyValue'

export const clean = (value) => ((number) => (isFinite(number) ? number : 0))(parseInt(value, 10))
const FEET_UNIT = "'"
const INCHES_UNIT = '"'

class Height extends SurveyValue {
  constructor(feet, inches) {
    super()

    this.feet = clean(feet)
    this.inches = clean(inches)
  }

  getFeet() {
    return this.feet
  }

  getFeetLabel() {
    return `${this.getFeet()}${FEET_UNIT}`
  }

  getInches() {
    return this.inches
  }

  getInchesLabel() {
    return `${this.getInches()}${INCHES_UNIT}`
  }

  toKey() {
    return `${this.getFeetLabel()}${this.getInchesLabel()}`
  }

  toLabel() {
    return `${this.getFeetLabel()}${this.getInches() ? this.getInchesLabel() : ''}`
  }

  toReadable() {
    return this.toKey()
  }

  toValidatable() {
    return `${this.getFeet() * 12 + this.getInches()}`
  }

  static keyToObject(key) {
    return new Height(
      key.substring(0, key.indexOf(FEET_UNIT)),
      key.substring(key.indexOf(FEET_UNIT) + 1, key.indexOf(INCHES_UNIT)),
    )
  }

  static toFeet(heightInInches) {
    return Math.floor(clean(heightInInches) / 12)
  }

  static toInches(heightInInches) {
    return clean(heightInInches) % 12
  }
}

export default Height
